module.exports = __webpack_public_path__ + "static/media/kfc-24-5.21adbcca.jpg";